import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { Avatar } from 'copilot-design-system';
import React from 'react';

import { FlagsContext } from 'src/context/flagsContext';
import { BaseResultItem } from 'src/legacy/components/CommandBar/BaseResultItem';
import {
  ClientAction,
  RenderParams,
} from 'src/legacy/components/CommandBar/commandBarTypes';
import BaseTypography from 'src/legacy/components/Text/BaseTypography';
import { BlackHeadings, GraySmall } from 'src/theme/colors';
import { getInitials } from 'src/utils/UserUtils';

interface UserResultItemProps extends RenderParams {
  item: RenderParams['item'] & ClientAction;
}
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    userNameText: {
      color: BlackHeadings,
    },
    userDetailsWrapper: {
      marginLeft: theme.spacing(2),
    },
    companyText: {
      color: GraySmall,
    },
  }),
);
/**
 * This component renders the user action result item
 */
export const UserResultItem: React.FC<UserResultItemProps> = ({
  item,
  active,
}) => {
  const classes = useStyles();
  const { EnableLegacyAvatarColorMapping } = React.useContext(FlagsContext);
  const { companyName, fallbackColor, pictureUrl } = item.additionalData;
  return (
    <BaseResultItem active={active}>
      <Avatar
        data-testid="user-avatar"
        src={pictureUrl ?? ''}
        text={getInitials(item.name, {
          twoLetters: true,
        })}
        fallbackColor={fallbackColor}
        variant="circle"
        size="sm"
        className="h-[35px] w-[35px]"
        useNewColors={EnableLegacyAvatarColorMapping}
      />
      <div className={classes.userDetailsWrapper}>
        <BaseTypography
          data-testid="user-name"
          className={classes.userNameText}
          fontType="13Medium"
        >
          {item.name}
        </BaseTypography>
        {companyName && (
          <BaseTypography
            data-testid="company-name"
            className={classes.companyText}
            fontType="12Regular"
          >
            {companyName}
          </BaseTypography>
        )}
      </div>
    </BaseResultItem>
  );
};
